import { createContext, useContext, useState } from "react";

export const translations = {
  it: {
    nav: { tech: "Tecnologia", numbers: "Numeri", manifesto: "Manifesto", contact: "Contatti", cta: "Richiedi Demo" },
    hero: {
      eyebrow: "PIATTAFORMA HARDWARE + SOFTWARE // FOOD SERVICE",
      line1: "PROCESSO",
      line2: "ACCELERATO",
      line3: "DI QUALITÀ",
      sub: "Una piattaforma integrata hardware e software per la cottura automatizzata ad alte prestazioni. Forni professionali compatti all-in-one — microonde + aria calda forzata — governati da cicli PAQ parametrizzati.",
      status: "SYSTEM: READY",
      cycle: "CICLO PAQ_04 // ATTIVO",
      scroll: "SCORRI",
    },
    tech: {
      label: "01 // IL MOTORE",
      title: "Doppia fonte.",
      titleAccent: "Singola precisione.",
      body: "La cottura combinata a microonde e aria calda forzata, orchestrata da firmware proprietario, elimina la variabilità umana. Ogni ciclo è un protocollo: parametrizzato, replicabile, tracciato.",
      f1t: "Microonde 2.45 GHz",
      f1d: "Energia volumetrica istantanea, al cuore del prodotto.",
      f2t: "Aria calda forzata",
      f2d: "Superfici dorate e texture perfetta. In minuti, non in ore.",
      f3t: "Sensoristica dedicata",
      f3d: "Temperatura e umidità lette in tempo reale, a ogni secondo del ciclo.",
      f4t: "Controllo digitale",
      f4d: "Firmware e software proprietari per regolazione, monitoraggio e tracciabilità.",
      blueprint: "SCHEMA TECNICO // REV 2.4",
      magnetron: "MAGNETRON // 2.45GHz",
      fan: "VENTOLA // 3200 RPM",
      sensor: "NTC // ±0.5°C",
      core: "PAQ CORE",
    },
    numbers: {
      label: "02 // I NUMERI",
      title: "Il risultato, misurato.",
      d1: "Tempi operativi",
      d2: "Standardizzazione del risultato",
      d3: "Efficienza energetica",
      d4: "Precisione termica",
      note: "Dati rilevati su cicli PAQ parametrizzati in ambiente di produzione.",
    },
    manifesto: {
      label: "03 // MANIFESTO",
      c1t: "La variabilità è il nemico.",
      c1d: "In cucina ogni mano è diversa, ogni turno è un rischio. PAQ trasforma la cottura in un processo: stesso input, stesso risultato, ovunque.",
      c2t: "Il dato guida il calore.",
      c2d: "Sensori, telemetria e firmware proprietario. Ogni ciclo genera dati che tarano, tracciano e ottimizzano il ciclo successivo. Anche i consumi.",
      c3t: "Compatto è il nuovo professionale.",
      c3d: "Una macchina all-in-one che sostituisce una linea. Meno spazio, meno energia, più controllo. Il food service cambia scala.",
    },
    marquee: ["COMPACT ALL-IN-ONE", "COTTURA COMBINATA", "SENSORISTICA AVANZATA", "CICLI PARAMETRIZZATI", "B2B FOOD SERVICE", "EFFICIENZA ENERGETICA"],
    contact: {
      label: "04 // CONTATTI",
      title: "Richiedi una demo.",
      body: "Raccontaci il tuo contesto operativo: ti mostreremo il PAQ in azione sui tuoi prodotti.",
      name: "Nome e cognome",
      company: "Azienda",
      email: "Email",
      message: "Messaggio",
      submit: "Invia richiesta",
      sending: "Invio in corso...",
      success: "Richiesta inviata. Ti ricontatteremo a breve.",
      error: "Errore nell'invio. Riprova.",
    },
    footer: {
      tagline: "Processo Accelerato di Qualità",
      rights: "© 2026 PAQ S.r.l. — Tutti i diritti riservati.",
      nav: "Indice",
      legal: "Privacy // Cookie",
      company: "PAQ S.R.L. — START UP INNOVATIVA",
      address: "VIA ERIDANIA OVEST, 65 — 45030 GUARDA VENETA (RO)",
      vat: "P.I. 01694180298",
      capital: "CAPITALE SOCIALE € 990.726 I.V.",
    },
  },
  en: {
    nav: { tech: "Technology", numbers: "Numbers", manifesto: "Manifesto", contact: "Contact", cta: "Request Demo" },
    hero: {
      eyebrow: "HARDWARE + SOFTWARE PLATFORM // FOOD SERVICE",
      line1: "ACCELERATED",
      line2: "QUALITY",
      line3: "PROCESS",
      sub: "An integrated hardware and software platform for high-performance automated cooking. Compact all-in-one professional ovens — microwave + forced hot air — driven by parametric PAQ cycles.",
      status: "SYSTEM: READY",
      cycle: "PAQ CYCLE_04 // ACTIVE",
      scroll: "SCROLL",
    },
    tech: {
      label: "01 // THE ENGINE",
      title: "Dual source.",
      titleAccent: "Single precision.",
      body: "Combined microwave and forced-hot-air cooking, orchestrated by proprietary firmware, eliminates human variability. Every cycle is a protocol: parametric, replicable, traced.",
      f1t: "Microwave 2.45 GHz",
      f1d: "Instant volumetric energy, straight to the core of the product.",
      f2t: "Forced hot air",
      f2d: "Golden surfaces and perfect texture. In minutes, not hours.",
      f3t: "Dedicated sensors",
      f3d: "Temperature and humidity read in real time, every second of the cycle.",
      f4t: "Digital control",
      f4d: "Proprietary firmware and software for regulation, monitoring and traceability.",
      blueprint: "TECHNICAL DRAWING // REV 2.4",
      magnetron: "MAGNETRON // 2.45GHz",
      fan: "FAN // 3200 RPM",
      sensor: "NTC // ±0.5°C",
      core: "PAQ CORE",
    },
    numbers: {
      label: "02 // THE NUMBERS",
      title: "The outcome, measured.",
      d1: "Operating times",
      d2: "Result standardization",
      d3: "Energy efficiency",
      d4: "Thermal precision",
      note: "Data measured on parametric PAQ cycles in a production environment.",
    },
    manifesto: {
      label: "03 // MANIFESTO",
      c1t: "Variability is the enemy.",
      c1d: "In a kitchen every hand is different, every shift is a risk. PAQ turns cooking into a process: same input, same result, anywhere.",
      c2t: "Data drives the heat.",
      c2d: "Sensors, telemetry and proprietary firmware. Every cycle generates data that calibrates, traces and optimizes the next one. Energy consumption included.",
      c3t: "Compact is the new professional.",
      c3d: "One all-in-one machine that replaces a line. Less space, less energy, more control. Food service changes scale.",
    },
    marquee: ["COMPACT ALL-IN-ONE", "COMBINED COOKING", "ADVANCED SENSOR SUITE", "PARAMETRIC CYCLES", "B2B FOOD SERVICE", "ENERGY EFFICIENCY"],
    contact: {
      label: "04 // CONTACT",
      title: "Request a demo.",
      body: "Tell us about your operational context: we will show you PAQ at work on your own products.",
      name: "Full name",
      company: "Company",
      email: "Email",
      message: "Message",
      submit: "Send request",
      sending: "Sending...",
      success: "Request sent. We will get back to you shortly.",
      error: "Submission failed. Please try again.",
    },
    footer: {
      tagline: "Accelerated Quality Process",
      rights: "© 2026 PAQ S.r.l. — All rights reserved.",
      nav: "Index",
      legal: "Privacy // Cookie",
      company: "PAQ S.R.L. — INNOVATIVE STARTUP",
      address: "VIA ERIDANIA OVEST, 65 — 45030 GUARDA VENETA (RO) — ITALY",
      vat: "VAT 01694180298",
      capital: "SHARE CAPITAL € 990,726 FULLY PAID",
    },
  },
};

const LanguageContext = createContext(null);

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState("it");
  const t = translations[lang];
  return (
    <LanguageContext.Provider value={{ lang, setLang, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => useContext(LanguageContext);
